module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.image) ? _c('div', {
    staticClass: "lightbox",
    on: {
      "click": _vm.close
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('lightbox-image', {
    key: _vm.image,
    attrs: {
      "image": _vm.image
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "lightbox__close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-3x"
  })]), _vm._v(" "), _c('div', {
    staticClass: "lightbox__btn lightbox__next",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.next($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right fa-3x"
  })]), _vm._v(" "), _c('div', {
    staticClass: "lightbox__btn lightbox__prev",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.prev($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-3x"
  })])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b78cab5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lightbox/Lightbox.vue
// module id = 442
// module chunks = 1